import Logger from 'js-logger';

import { axiosReset } from '../../../shared/utils/setCommonHeaders';
import { saveAuthTokens, fetchLogin } from '../../login/ducks/loginActions';

import {
  SUBMIT_EMAIL_START,
  SUBMIT_EMAIL_FULFILLED,
  SUBMIT_EMAIL_REJECTED,
  SUBMIT_RESET_START,
  SUBMIT_RESET_FULFILLED,
  SUBMIT_RESET_REJECTED,
  VALIDATE_TOKEN_START,
  VALIDATE_TOKEN_FULFILLED,
  VALIDATE_TOKEN_REJECTED,
} from './actionTypes';

// isIdnty picks the endpoint, not a body field - forgot-password-idnty's
// schema now rejects it as an extra property, since the endpoint itself is
// already the IDNTY signal (the backend hardcodes isIdnty from there).
// programId is never appended to the emailed link itself - a query param
// can be stripped by email clients or tampered with; the backend embeds it
// in the token instead. easyJoinId isn't needed until the later
// registerExistingUser call.
export const submitForgot = (values, isIdnty, programId) => (
  (dispatch) => {
    dispatch({ type: SUBMIT_EMAIL_START });
    const endpoint = isIdnty ? '/public/forgot-password-idnty' : '/public/forgot-password';
    return axiosReset.post(endpoint, {
      ...values,
      // programId is always a string here (URLSearchParams.get()); the
      // endpoint's schema requires an integer.
      ...(programId && { programId: Number(programId) }),
    })
      .then(() => {
        setTimeout(() => {
          dispatch({
            type: SUBMIT_EMAIL_FULFILLED,
            payload: values.email,
          });
        }, 800);
        return { success: true };
      })
      .catch((err) => {
        dispatch({
          type: SUBMIT_EMAIL_REJECTED,
          payload: err,
        });
        Logger.debug(err);
        return {
          message: err?.response?.headers?.message || 'Something went wrong, please try again.',
          success: false,
        };
      });
  }
);

// For IDNTY, saveAuthTokens/fetchLogin are deliberately skipped - joining
// IDNTY must never establish a real session on its own (see
// registrationActions.js). isIdnty is not sent to the backend here - it's
// baked into the reset token itself (set by submitForgot's
// forgot-password-idnty call), which the backend uses to decide whether to
// echo back email/programId for the subsequent registerExistingUser call.
export const submitReset = (values, isIdnty = false) => (
  (dispatch) => {
    dispatch({ type: SUBMIT_RESET_START });
    return axiosReset.post('/public/reset-password', values)
      .then((response) => {
        const { data } = response;
        setTimeout(() => {
          dispatch({
            type: SUBMIT_RESET_FULFILLED,
            payload: response.data,
          });
        }, 800);
        if (!isIdnty) {
          saveAuthTokens(data.v2_token, data.accessToken, data.refreshToken, data.expires_in);
          dispatch(fetchLogin());
        }
        return data;
      })
      .catch((err) => {
        dispatch({
          type: SUBMIT_RESET_REJECTED,
          payload: err,
        });
        Logger.debug(err);
      });
  }
);

// Validate the temporary token before allowing password reset
export const validateToken = (values) => (
  (dispatch) => {
    dispatch({ type: VALIDATE_TOKEN_START });
    axiosReset.post('/public/validate-reset-token', values)
      .then((response) => {
        const { data } = response.data;
        setTimeout(() => {
          dispatch({
            type: VALIDATE_TOKEN_FULFILLED,
            payload: data,
          });
        }, 800);
      })
      .catch((err) => {
        dispatch({
          type: VALIDATE_TOKEN_REJECTED,
          payload: {
            message: err.response?.headers?.message || 'Invalid token, please try again',
            status: err.response?.status,
          },
        });
        Logger.debug(err);
      });
  }
);

// Validate the temporary token before allowing password set
export const validateTokenSet = (values) => (
  (dispatch) => {
    dispatch({ type: VALIDATE_TOKEN_START });
    axiosReset.post('/public/validate-set-password-token', values)
      .then((response) => {
        const { data } = response.data;
        setTimeout(() => {
          dispatch({
            type: VALIDATE_TOKEN_FULFILLED,
            payload: data,
          });
        }, 800);
      })
      .catch((err) => {
        dispatch({
          type: VALIDATE_TOKEN_REJECTED,
          payload: {
            message: err.response?.headers?.message || 'Invalid token, please try again',
            status: err.response?.status,
          },
        });
        Logger.debug(err);
      });
  }
);
